export const DEFAULT_MASK_ICON_SIZE = 20;
export const DEFAULT_MASK_ICON_COLOR = "currentColor";
